
import  Cookies from 'js-cookie';

const Session = {

    // Session Cookie Expiration set to 1 Day; User Idle Session timeout of 30 min. overrides this
    EXPIRES: 1,

    destroy: function() {
        // User Logout or Session is invalid - Terminate Session & Destroy cookie
        Cookies.remove('session');
    },

    expired: function(redirectURL) {
        // User Session Expired - this.destroy() + Redirect User Home => Central Auth
        Session.destroy();
        location.href = redirectURL;
    },

    get: function() {
        // User Actions - Return Session & User Info
        
        return Cookies.getJSON('session') || {};
    },

    set: function(id, profile, authState, token) {
        // User Login Authentication - Store Info in Session
        Session.update(id, profile, authState, token);
    },

    update: function(id, profile, authState, token) {
        // Update Session Info
        sessionStorage.setItem("auth_session_Token", `Bearer ${token}`);
        let sessionObj = {
            authState : authState,
            expires   : Session['EXPIRES'],
            user: {
                profile : profile,
                token   : token
            }
        };
        Cookies.set('session', sessionObj);
    }
};

export default Session
